import React from 'react';
import { compose, pure } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const styles = {
  iconMid: {
    padding: '5px',
    fontSize: 14
  },
  bigButton: {
    width: '100%',
    backgroundColor: 'white',
    borderRadius: 0,
    padding: '4px 0',
    color: '#2196f3'
  },
  text: {
    fontSize: 12,
    fontWeight: 600,
    color: 'rgba(0, 0, 0, 0.87)'
  }
};

const enhance = compose(pure);

const button = enhance(({ classes, classStyle, label, onClickAction }) => {
  return (
    <Button
      className={classes.bigButton}
      onClick={() => {
        onClickAction();
      }}
    >
      <i className={`${classStyle} ${classes.iconMid}`} />
      <div className={classes.text}>{label}</div>
    </Button>
  );
});

export default withStyles(styles)(button);
